<div class="no-data-dashboard" *ngIf="data">
    <app-getting-start-section [sections1]="data.sections[0]"></app-getting-start-section>
    <app-config-section [sections2]="data.sections[1]" [moduleName]="moduleName"></app-config-section>
    <app-video-card-section *ngIf="!isModalView" [sections3]="data.sections[2]" [moduleName]="moduleName" [isSubModule]="isSubModule"></app-video-card-section>
</div>


<!-- <div class="scroll-child" *ngIf="data">
    <div class="container-module">
    <h1>{{ data.page }}</h1>
    ---Getting to Know the Asset Module---
    <app-getting-start-section [sections1]="data.sections[0]" [showTourLink]="showTourLink"></app-getting-start-section>
    -AI Import Section-
    <app-ai-import-section [sections2]="data.sections[1]"></app-ai-import-section>
    -Video Section-
    <app-video-card-section [sections3]="data.sections[2]"></app-video-card-section>
    -Config Section-
    <app-config-section [sections4]="data.sections[3]"></app-config-section>
    </div>
</div> -->